import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { login, getToken } from "@/lib/adminApi";

export default function AdminLogin() {
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (getToken()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(password);
      toast.success("Connecté");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err.response?.status === 401 ? "Mot de passe incorrect" : "Erreur");
    }
    setLoading(false);
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      data-testid="admin-login-page"
    >
      <form
        onSubmit={submit}
        className="w-full max-w-md p-8 rounded-3xl border border-yellow-500/30"
        style={{
          background: "linear-gradient(180deg, #0a0805, #050505)",
          boxShadow: "0 30px 80px -20px rgba(212,175,55,0.3)",
        }}
        data-testid="admin-login-form"
      >
        <div className="flex justify-center mb-6">
          <div className="w-14 h-14 rounded-full bg-yellow-500/15 flex items-center justify-center">
            <Lock className="w-6 h-6 text-yellow-300" />
          </div>
        </div>
        <h1
          className="text-3xl font-black text-center mb-2"
          style={{
            fontFamily: '"Bebas Neue", system-ui',
            background: "linear-gradient(180deg, #fff, #F4D77A)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          Admin Braf_Zak
        </h1>
        <p className="text-center text-white/50 text-sm mb-8">
          Espace privé — gestion du catalogue
        </p>
        <input
          type="password"
          required
          autoFocus
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input"
          className="w-full px-5 py-4 rounded-xl bg-white/5 border border-yellow-500/20 text-white placeholder-white/40 focus:outline-none focus:border-yellow-400 mb-4"
        />
        <Button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit"
          className="w-full rounded-full font-bold tracking-widest text-black py-6 disabled:opacity-50"
          style={{
            background: "linear-gradient(180deg, #F4D77A, #D4AF37)",
            boxShadow: "0 12px 30px -8px rgba(212,175,55,0.5)",
          }}
        >
          {loading ? "..." : "SE CONNECTER"}
        </Button>
      </form>
    </div>
  );
}
